(function () {
  function readItem(el) {
    var raw = el.getAttribute('data-ga4-item');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function sumValue(items) {
    return items.reduce(function (total, item) {
      var price = parseFloat(item.price);
      var qty = parseFloat(item.quantity) || 1;
      return isNaN(price) ? total : total + price * qty;
    }, 0);
  }

  function listContext() {
    var ctx = window.karmaListContext || {};
    return { name: ctx.name || undefined, id: ctx.id || undefined };
  }

  function pushViewItemList() {
    var items = Array.prototype.slice
      .call(document.querySelectorAll('[data-ga4-item]'))
      .map(readItem)
      .filter(Boolean);
    if (!items.length) return;

    var ctx = listContext();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'view_item_list',
      ecommerce: {
        currency: window.shopCurrency,
        value: sumValue(items),
        item_list_name: ctx.name,
        item_list_id: ctx.id,
        items: items,
      },
    });
  }

  document.addEventListener('click', function (evt) {
    var listItem = evt.target.closest('[data-ga4-item]');
    if (listItem) {
      var item = readItem(listItem);
      if (item) {
        var ctx = listContext();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_item',
          ecommerce: {
            currency: window.shopCurrency,
            item_list_name: ctx.name,
            item_list_id: ctx.id,
            items: [item],
          },
        });
      }
      return;
    }

    var checkoutButton = evt.target.closest('button[name="checkout"]');
    if (checkoutButton) {
      var cartItemsRaw = checkoutButton.getAttribute('data-cart-items');
      var cartItems = [];
      if (cartItemsRaw) {
        try {
          cartItems = JSON.parse(cartItemsRaw);
        } catch (e) {
          cartItems = [];
        }
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          currency: checkoutButton.getAttribute('data-cart-currency') || undefined,
          value: parseFloat(checkoutButton.getAttribute('data-cart-value')) || undefined,
          items: cartItems,
        },
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pushViewItemList);
  } else {
    pushViewItemList();
  }
})();
